<template>
  <q-chips-input
    v-model="searchQuery"
    :float-label="placeholder"
    clearable
    :disable="disable"
    @clear="clear"
    @remove="remove"
  >
    <q-autocomplete
      :min-characters="minCharacters"
      :max-results="20"
      @search="runSearch"
      @selected="add"
    />
  </q-chips-input>
</template>

<script>
import { ref } from '@vue/composition-api';
import { search } from '@/utils/SearchUtil';

export default {
  name: 'AutocompleteChips',
  props: {
    method: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Search...',
    },
    dataKey: {
      type: String,
      required: true,
    },
    filters: {
      type: Object,
      default: null,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    minCharacters: {
      type: Number,
      default: 2,
    },
  },
  setup(props, context) {
    const searchQuery = ref([]);
    const selectedItems = ref([]);

    return {
      searchQuery,
      runSearch,
      add,
      remove,
      clear,
    };

    async function runSearch(query, done) {
      const filters = props.filters || {};
      const items = await search(query, props.method, filters);
      done(items);
    }
    function add(item, navigateWithKeyboardArrows) {
      if (!navigateWithKeyboardArrows) {
        selectedItems.value.push(item);
        context.emit('change', selectedItems.value, navigateWithKeyboardArrows);
      }
    }
    function remove({ value }) {
      selectedItems.value = selectedItems.value.filter((item) => String(item.data[props.dataKey]) !== value[0]);
      context.emit('change', selectedItems.value, false);
    }
    function clear() {
      selectedItems.value = [];
      context.emit('change', null, false);
    }
  },
};
</script>
